import { FC, Fragment } from 'react';
import { Accordion, AccordionTitleDetail, Button, Flex, Table } from '../../../../../components/shared';
import { FormikProps } from 'formik';
import { PeopleProfileOrganisationFormType } from '../../../../../utils/types';
import { Edit2, X } from 'react-feather';
import { FiCheckCircle } from 'react-icons/fi';
import { useEditOrganisationModalForm } from './EditOrganisationModalForm';
import { getPeopleProfileOrganisationFormTypeDefault } from '../../../../../utils/format';
import { usePromptModalForm2 } from '../../../../../components/shared/promptModalForm';
import { FormType } from '../FieldsForPeople';

export type OrganisationCardValuesType = {
  associatedOrganisations: PeopleProfileOrganisationFormType[];
};

export type OrganisationsCardPropsType = {
  formikProps: FormikProps<FormType>;
  viewMode?: boolean;
  currentOrganisationsOnly?: boolean;
};

const OrganisationsCard: FC<OrganisationsCardPropsType> = props => {
  const formikProps = props.formikProps;
  const values = formikProps.values;
  const viewMode = props.viewMode === true;
  // const currentOrganisationsOnly = props.currentOrganisationsOnly === true;

  const [EditOrganisationModalForm, showEditOrganisationModalForm] = useEditOrganisationModalForm();
  const [PromptModalForm, showPromptModalForm] = usePromptModalForm2();

  const COLUMNS = [
    {
      id: 'primary',
      Header: 'Primary',
      //width: '60px',
      accessor: (row: PeopleProfileOrganisationFormType) => (
        <Fragment>{row.primary && <FiCheckCircle color="#4C9A5C" fontSize="1.5em" strokeWidth={3} />}</Fragment>
      ),
    },
    {
      id: 'name',
      Header: 'Name',
      accessor: 'organisation.name',
    },
    {
      id: 'designation',
      Header: 'Designation',
      accessor: 'designation',
    },
    ...(viewMode
      ? []
      : [
          {
            id: 'actions',
            accessor: (row: PeopleProfileOrganisationFormType) => (
              <Flex direction="row" size="1" justify="flex-end">
                <Button
                  bg="warning"
                  icon={<Edit2 />}
                  isIcon={true}
                  mr={1}
                  p={0}
                  type="button"
                  width="40px"
                  onClick={() => {
                    onEdit(row);
                  }}
                />
                <Button
                  bg="error"
                  icon={<X />}
                  isIcon={true}
                  mr={1}
                  p={0}
                  type="button"
                  width="40px"
                  onClick={() => {
                    onDelete(row);
                  }}
                />
              </Flex>
            ),
          },
        ]),
  ];

  const fixupPrimaries = (values: PeopleProfileOrganisationFormType[], changed: PeopleProfileOrganisationFormType) => {
    if (changed.primary) {
      values.forEach(value => {
        if (value.id !== changed.id) {
          // only one primary per person/roletype(stakeholder type)
          if (value.primary) {
            value.primary = false;
          }
        }
      });
    }
  };

  const onNew = () => {
    values['nosubmit'] = true;
    showEditOrganisationModalForm(
      getPeopleProfileOrganisationFormTypeDefault(),
      values,
      (cancel: boolean, data: PeopleProfileOrganisationFormType) => {
        values['nosubmit'] = false;
        if (!cancel) {
          values.associatedOrganisations.push(data);
          fixupPrimaries(values.associatedOrganisations, data);
        }
      }
    );
  };

  const onEdit = (item: PeopleProfileOrganisationFormType) => {
    values['nosubmit'] = true;
    showEditOrganisationModalForm(item, values, (cancel: boolean, data: PeopleProfileOrganisationFormType) => {
      values['nosubmit'] = false;
      if (!cancel) {
        const index = values.associatedOrganisations.findIndex(x => x.id === data.id);
        if (index >= 0) {
          values.associatedOrganisations[index] = data;
          fixupPrimaries(values.associatedOrganisations, data);
        }
      }
    });
  };

  const onDelete = (item: PeopleProfileOrganisationFormType) => {
    const index = values.associatedOrganisations.findIndex(x => x.id === item.id);
    if (index >= 0) {
      values['nosubmit'] = true;
      showPromptModalForm({
        id: item.id,
        heading: 'Delete',
        buttons: 'delete',
        onDone: (promptId: string, button: string, cancelled: boolean, id: string) => {
          values['nosubmit'] = false;
          if (!cancelled) {
            values.associatedOrganisations.splice(index, 1);
          }
        },
      });
    }
  };

  // const getData = (
  //   data: PeopleProfileOrganisationFormType[],
  //   currentOnly: boolean
  // ): PeopleProfileOrganisationFormType[] => {
  //   const now = new Date();
  //   if (currentOnly) {
  //     return data.filter(x => x.startDate <= now && now <= x.endDate);
  //   }
  //   return data;
  // };

  return (
    <Fragment>
      <EditOrganisationModalForm />
      <PromptModalForm />

      <Accordion
        key={'associatedOrganisation'}
        title={`Organisations (${values.associatedOrganisations.length})`}
        titleDetail={
          <Fragment>
            {!viewMode && (
              <AccordionTitleDetail
                onClick={() => {
                  onNew();
                }}
                propagateOnClick={false}
                text={'+ New'}
              />
            )}
          </Fragment>
        }
      >
        <Table
          defaultPageSize={5}
          padding={0}
          showHeader={false}
          loading={false}
          hideActionButton={true}
          columns={COLUMNS}
          data={values.associatedOrganisations}
        />
      </Accordion>
    </Fragment>
  );
};

export default OrganisationsCard;
